<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <formWrapper :validator="$v.form">
        <v-form @submit.prevent="handleSubmit">
          <v-row>
            <v-col
              v-if="$route.name === 'edit'"
              cols="12"
              md="12"
              class="mx-auto"
            >
              <locale-select v-model="locale" @change="changeLocale" />
            </v-col>
            <v-col cols="12" md="6">
              <form-group
                name="cooperative_acceptance"
                attribute="fields.cooperative_acceptance"
              >
                <span>
                  {{ $t("fields.cooperative_acceptance") }}
                  <sup>
                    <strong style="font-size:1rem">*</strong>
                  </sup>
                </span>

                <fileUpload
                  :file_url="media.cooperative_acceptance"
                  :file_id="media.cooperative_acceptance.id"
                  @fileSelected="
                    onFileSelected($event, 'cooperative_acceptance')
                  "
                  class="file-upload__image"
                  :maxSize="maxSize"
                />
              </form-group>
            </v-col>
            <v-col class="mb-5" cols="12" md="6">
              <form-group
                name="government_acceptance"
                attribute="fields.government_acceptance"
              >
                <span>
                  {{ $t("fields.government_acceptance") }}
                  <sup>
                    <strong style="font-size:1rem">*</strong>
                  </sup>
                </span>
                <fileUpload
                  :file_url="media.government_acceptance"
                  :file_id="media.government_acceptance.id"
                  @fileSelected="
                    onFileSelected($event, 'government_acceptance')
                  "
                  class="file-upload__image"
                  :maxSize="maxSize"
                />
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="name" attribute="fields.name">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.name"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="email" attribute="fields.email">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    type="email"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.email"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="country" attribute="fields.country">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.country"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="region" attribute="fields.region">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.region"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="state" attribute="fields.state">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.state"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="district" attribute="fields.district">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.district"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="city" attribute="fields.city">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.city"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="street" attribute="fields.street">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.street"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="building_no" attribute="fields.building_no">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.building_no"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="postal_code" attribute="fields.postal_code">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.postal_code"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="postbox" attribute="fields.postbox">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.postbox"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12" md="6">
              <form-group name="additional_no" attribute="fields.additional_no">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.additional_no"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                readonly
                v-model="form.fax_phone.country_code"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="10">
              <form-group
                name="fax_phone.phone"
                attribute="fields.fax_phone.phone"
              >
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.fax_phone.phone"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                readonly
                v-model="form.mobile_phone.country_code"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="10">
              <form-group
                name="mobile_phone.phone"
                attribute="fields.mobile_phone.phone"
              >
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.mobile_phone.phone"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                readonly
                v-model="form.landline_phone.country_code"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="10">
              <form-group
                name="landline_phone.phone"
                attribute="fields.landline_phone.phone"
              >
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.landline_phone.phone"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <google-maps
                    :center="center"
                    @markerUpdated="onUpdateMarker"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <form-group name="lat" attribute="fields.lat">
                    <template slot-scope="{ attrs, listeners }">
                      <v-text-field
                        type="number"
                        @input="handleCenter"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model.number="form.lat"
                        outlined
                      ></v-text-field>
                    </template>
                  </form-group>
                </v-col>
                <v-col cols="12" md="6">
                  <form-group name="lng" attribute="fields.lng">
                    <template slot-scope="{ attrs, listeners }">
                      <v-text-field
                        type="number"
                        @input="handleCenter"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model.number="form.lng"
                        outlined
                      ></v-text-field>
                    </template>
                  </form-group>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-btn
            :disabled="$v.form.$invalid"
            type="submit"
            :loading="loading"
            class="primary"
          >
            <span>{{ $t("button.save") }}</span>
            <v-icon small right>mdi-send</v-icon>
          </v-btn>
        </v-form>
      </formWrapper>
    </v-container>
  </main>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  email
} from "vuelidate/lib/validators";
import { validPhoneNumber, validateHomeNumber } from "@/utils/validate";
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
export default {
  name: "FormAction",
  components: {
    fileUpload: () => import("@/components/fileUpload")
  },
  data() {
    return {
      form: {
        name: "",
        country: "",
        region: "",
        city: "",
        state: "",
        district: "",
        street: "",
        building_no: "",
        email: "",
        fax_phone: {
          country_code: "+966",
          phone: ""
        },
        mobile_phone: {
          country_code: "+966",
          phone: ""
        },
        landline_phone: {
          country_code: "+966",
          phone: ""
        },
        cooperative_acceptance: {},
        government_acceptance: {},
        postbox: "",
        postal_code: "",
        lat: "",
        lng: ""
      },
      center: {
        lat: 0,
        lng: 0
      },
      locale: this.locale,
      loading: false,
      maxSize: 2045,
      media: {
        cooperative_acceptance: {},
        government_acceptance: {}
      }
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      country: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      region: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      city: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      street: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      state: {
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      district: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      building_no: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      additional_no: {
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      email: {
        required,
        email,
        maxLength: maxLength(50)
      },
      fax_phone: {
        phone: {
          validateHomeNumber
        }
      },
      mobile_phone: {
        phone: {
          validPhoneNumber
        }
      },
      landline_phone: {
        phone: {
          validateHomeNumber
        }
      },
      postbox: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100)
      },
      postal_code: {
        required,
        minLength: minLength(3)
      },
      lat: {
        required
      },
      lng: {
        required
      },
      cooperative_acceptance: {
        required
      },
      government_acceptance: {
        required
      }
    }
  },
  methods: {
    onFileSelected(file, keyName) {
      this.form[keyName] = file.file;
    },
    handleCenter() {
      this.center = {
        lat: this.form.lat,
        lng: this.form.lng
      };
    },
    onUpdateMarker({ lat, lng }) {
      this.form.lat = lat;
      this.form.lng = lng;
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },

    handleSubmit() {
      this.loading = true;
      const formData = new FormData();
      if (this.$route.name !== "create") {
        delete this.form.cooperative_acceptance;
        delete this.form.government_acceptance;
      }
      for (const key in this.form) {
        if (
          key !== "fax_phone" &&
          key !== "landline_phone" &&
          key !== "mobile_phone"
        ) {
          formData.append(key, this.form[key]);
        } else {
          formData.append(`${key}.phone`, this.form[key].phone);
          formData.append(`${key}.country_code`, this.form[key].country_code);
        }
      }
      formData.append("locale", this.locale);

      if (this.$route.name === "create") {
        // in case create
        this.createBranch(formData);
      } else {
        // in case edit
        formData.append("_method", "put");

        this.editbranches(formData);
      }
    },
    async createBranch(data) {
      try {
        await StoreData({ reqName: "branches", data });
        this.$router.push({ name: "branches" });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editbranches(data) {
      const { slug } = this.$route.params;
      UpdateData({ reqName: "branches", data, param: slug })
        .then(() => this.$router.push({ name: "branches" }))
        .finally(() => (this.loading = false));
    },
    handleShowData(locale) {
      const { slug } = this.$route.params;

      if (slug) {
        ShowData({ reqName: "branches", param: slug, locale }).then(res => {
          const { branch } = res.data;
          for (const key in this.media) {
            this.media[key] = branch[key];
          }
          this.form = branch;
          this.center.lat = parseFloat(branch.lat);
          this.center.lng = parseFloat(branch.lng);
        });
      }
    }
  },
  computed: {
    formTitle() {
      if (this.$route.name === "create") {
        return this.$t("headings.create_branches");
      } else {
        return this.$t("headings.edit_branches");
      }
    }
  },
  watch: {
    $route: {
      handler() {
        this.handleShowData();
      },
      immediate: true
    }
  }
};
</script>
